/* eslint-disable @typescript-eslint/ban-ts-comment */

/** Internal type. DO NOT USE DIRECTLY. */
import { gql } from "@apollo/client"
import * as Apollo from "@apollo/client"

import * as Types from "../../../shared/types/__generated__/graphql"

type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] }
/** Internal type. DO NOT USE DIRECTLY. */
export type Incremental<T> =
  | T
  | {
      [P in keyof T]?: P extends " $fragmentName" | "__typename" ? T[P] : never
    }
const defaultOptions = {} as const
export type CreateProjectImportInput = {
  id: string
  projectFields: ProjectImportProjectFieldsInput
  s3Key: string
}

export type ProjectImportProjectFieldsInput = {
  id: string
  phaseId: string
  title: string
}

export type CreateProjectImportMutationVariables = Exact<{
  input: Types.CreateProjectImportInput
}>

export type CreateProjectImportMutation = {
  __typename: "Mutation"
  projectImport: {
    __typename: "ProjectImport"
    id: string
    status?: string | null
    error?: Array<{
      __typename: "ProjectImportError"
      isValid?: boolean | null
      rowIndex?: number | null
      errors?: Array<string> | null
      warnings?: Array<string> | null
    }> | null
  }
}

export type ProjectImportQueryVariables = Exact<{
  id: string
}>

export type ProjectImportQuery = {
  __typename: "Query"
  projectImport: {
    __typename: "ProjectImport"
    id: string
    status?: string | null
    error?: Array<{
      __typename: "ProjectImportError"
      isValid?: boolean | null
      rowIndex?: number | null
      errors?: Array<string> | null
      warnings?: Array<string> | null
    }> | null
  }
}

export const CreateProjectImportDocument = gql`
  mutation CreateProjectImport($input: CreateProjectImportInput!) {
    projectImport: createProjectImport(input: $input)
      @rest(
        type: "ProjectImport"
        endpoint: "projectImport"
        method: "POST"
        path: "/project-list/projects/imports"
        bodySerializer: "projectImport"
      ) {
      id
      status
      error @type(name: "ProjectImportError") {
        isValid
        rowIndex
        errors
        warnings
      }
    }
  }
`
export type CreateProjectImportMutationFn = Apollo.MutationFunction<
  CreateProjectImportMutation,
  CreateProjectImportMutationVariables
>

/**
 * __useCreateProjectImportMutation__
 *
 * To run a mutation, you first call `useCreateProjectImportMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateProjectImportMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createProjectImportMutation, { data, loading, error }] = useCreateProjectImportMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateProjectImportMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CreateProjectImportMutation,
    CreateProjectImportMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    CreateProjectImportMutation,
    CreateProjectImportMutationVariables
  >(CreateProjectImportDocument, options)
}
export type CreateProjectImportMutationHookResult = ReturnType<
  typeof useCreateProjectImportMutation
>
export type CreateProjectImportMutationResult =
  Apollo.MutationResult<CreateProjectImportMutation>
export type CreateProjectImportMutationOptions = Apollo.BaseMutationOptions<
  CreateProjectImportMutation,
  CreateProjectImportMutationVariables
>
export const ProjectImportDocument = gql`
  query ProjectImport($id: ID!) {
    projectImport(id: $id)
      @rest(
        type: "ProjectImport"
        endpoint: "projectImport"
        path: "/project-list/projects/imports/{args.id}"
      ) {
      id
      status
      error @type(name: "ProjectImportError") {
        isValid
        rowIndex
        errors
        warnings
      }
    }
  }
`

/**
 * __useProjectImportQuery__
 *
 * To run a query within a React component, call `useProjectImportQuery` and pass it any options that fit your needs.
 * When your component renders, `useProjectImportQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProjectImportQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useProjectImportQuery(
  baseOptions: Apollo.QueryHookOptions<
    ProjectImportQuery,
    ProjectImportQueryVariables
  > &
    (
      | { variables: ProjectImportQueryVariables; skip?: boolean }
      | { skip: boolean }
    )
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<ProjectImportQuery, ProjectImportQueryVariables>(
    ProjectImportDocument,
    options
  )
}
export function useProjectImportLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    ProjectImportQuery,
    ProjectImportQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<ProjectImportQuery, ProjectImportQueryVariables>(
    ProjectImportDocument,
    options
  )
}
// @ts-ignore
export function useProjectImportSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    ProjectImportQuery,
    ProjectImportQueryVariables
  >
): Apollo.UseSuspenseQueryResult<
  ProjectImportQuery,
  ProjectImportQueryVariables
>
export function useProjectImportSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        ProjectImportQuery,
        ProjectImportQueryVariables
      >
): Apollo.UseSuspenseQueryResult<
  ProjectImportQuery | undefined,
  ProjectImportQueryVariables
>
export function useProjectImportSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        ProjectImportQuery,
        ProjectImportQueryVariables
      >
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<
    ProjectImportQuery,
    ProjectImportQueryVariables
  >(ProjectImportDocument, options)
}
export type ProjectImportQueryHookResult = ReturnType<
  typeof useProjectImportQuery
>
export type ProjectImportLazyQueryHookResult = ReturnType<
  typeof useProjectImportLazyQuery
>
export type ProjectImportSuspenseQueryHookResult = ReturnType<
  typeof useProjectImportSuspenseQuery
>
export type ProjectImportQueryResult = Apollo.QueryResult<
  ProjectImportQuery,
  ProjectImportQueryVariables
>
